'use client';

import { MaskType, MaskVariant } from '~/components/primitives';

import Image, { type ImageProps } from 'next/image';
import React from 'react';
import { cx } from 'class-variance-authority';

interface OptimizeImageProps {
    src: string;
    width: number;
    height?: number;
    quality?: number;
}

const storyblokLoader = ({ src, width, height = 0, quality = 75 }: OptimizeImageProps) =>
    `${src}/m/${width}x${height}/smart/filters:quality(${quality})`; // TODO: Add focal point

/** @TODO: refactor so that this just receives a SB asset */
const StoryblokImage: React.FC<
    Pick<
        ImageProps,
        'src' | 'alt' | 'width' | 'height' | 'style' | 'fill' | 'priority' | 'sizes' | 'className'
    > & {
        maskType?: MaskType;
    }
> = ({ maskType, fill = true, priority = false, sizes = '100vw', className, ...props }) => {
    return (
        props.src && (
            <Image
                {...props}
                fill={fill}
                loader={storyblokLoader}
                sizes={sizes}
                className={cx(
                    'object-cover',
                    className,
                    maskType && MaskVariant({ mask: maskType }),
                )}
            />
        )
    );
};

export default StoryblokImage;
